import { queryOptions } from '@tanstack/react-query';
import { OrganizationService } from './services/OrganizationService';

export const organizationQueryKeys = {
  all: ['organizations'] as const,
  list: () => [...organizationQueryKeys.all, 'list'] as const,
  details: () => [...organizationQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...organizationQueryKeys.details(), id] as const,
  membersList: () => [...organizationQueryKeys.all, 'members'] as const,
  members: (id: number) => [...organizationQueryKeys.membersList(), id] as const,
};

export const organizationQueries = {
  list: () =>
    queryOptions({
      queryKey: organizationQueryKeys.list(),
      queryFn: () => OrganizationService.getList(),
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: organizationQueryKeys.detail(id),
      queryFn: () => OrganizationService.getById(id),
    }),

  membersList: () =>
    queryOptions({
      queryKey: organizationQueryKeys.membersList(),
      queryFn: () => OrganizationService.getMembersList(),
    }),

  members: (id: number) =>
    queryOptions({
      ...organizationQueries.membersList(),
      select: (data) => data.filter((m) => m.partner === id),
    }),
};
